window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {


  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },


  initCart: function() {

    $('.cart-icon').click(function(e) {
      e.preventDefault();

      if($('#mobile-site-nav-list').hasClass('show-menu')) {
        $('#mobile-hamburger-toggle').trigger('click');
      }

      if($('#mini-cart').hasClass('is-open')) {
        $('#mini-cart').removeClass('is-open');
      } else {
        //window.scroll(0,0);
        $('#mini-cart').addClass('is-open');
      }
    });

    $('.close-cart').click(function(e) {
      e.preventDefault();
      $('#mini-cart').removeClass('is-open');
    });

    if($('[data-cart-json]').length != 0) {
      this.shopify_cart = JSON.parse($('[data-cart-json]').first().html());
    } else {
      this.shopify_cart = {};
    }
    this.buildMiniCart();

    // set up normal add to cart form
    $('form[action="/cart/add"],form[id="add-to-cart-form"]').submit(function(e) {
      e.preventDefault();
      $form = $(this);

      console.log('submit cart');

      // we are adding a gift so remove everything else from the cart
      // if( $form.find('input[name="properties[_is_gift]"]').val() == "1" ) {
      //   $.post('/cart/clear.js', {}, function(data) {
      //     console.log('cleared cart');
      //     slate.cart.submitCartForm($form, function() {
      //       console.log('redirecting ');
      //       window.location.href = '/checkout';
      //     });
      //   }.bind($form), 'json');
      // } else {

      //   // we're adding a non-gift so let's make sure there are no gifts in the cart
      //   var has_gifts = false;
      //   for(var i in slate.cart.shopify_cart.items) {
      //     for(var j in slate.cart.shopify_cart.items[i].properties) {
      //       if(j == '_is_gift' && slate.cart.shopify_cart.items[i].properties[j] == 1 || j == '_is_bundle_gift') {
      //         has_gifts = true;
      //         break;
      //       }
      //     }
      //     if(has_gifts) break;
      //   }

      //   if(has_gifts) {
      //     $.post('/cart/clear.js', {}, function(data) {
      //       slate.cart.submitCartForm($form);
      //     }.bind($form), 'json');
      //   } else {
      //     slate.cart.submitCartForm($form);
      //   }
      // }
      slate.cart.submitCartForm($form);
      (function(win, doc, sdk_url){ if(win.snaptr) return; var tr=win.snaptr=function(){ tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments); }; tr.queue = []; var s='script'; var new_script_section=doc.createElement(s); new_script_section.async=!0; new_script_section.src=sdk_url; var insert_pos=doc.getElementsByTagName(s)[0]; insert_pos.parentNode.insertBefore(new_script_section, insert_pos); })(window, document, 'https://sc-static.net/scevent.min.js'); snaptr('init','03f8b988-d302-4e42-b1d3-bbdec0c2c67a',{ 'user_email':'' }); snaptr('track','ADD_CART');

    });
  },



  buildMiniCart: function() {

    $('#mini-cart-items').empty();
    /* now add everything else */
    for(var i in this.shopify_cart.items) {
      // if(this.shopify_cart.items[i].product_type == 'Candles' || this.shopify_cart.items[i].product_type == 'Extras' || this.shopify_cart.items[i].product_type == 'Gift Card') continue;
      if(this.shopify_cart.items[i].product_type == 'Extras' || this.shopify_cart.items[i].product_type == 'Gift Card') continue;
      //if(this.shopify_cart.items[i].handle.indexOf('-platform') !== -1) continue;

      var sub_item = false;
      for(var p in this.shopify_cart.items[i].properties) {
        if(p == '_parent') {
          sub_item = this.shopify_cart.items[i].properties[p];
          break;
        }
      }
      // add a hidden list item for the sub items that may have been unaccounted for
      if(sub_item !== false && $('#item-' + this.shopify_cart.items[i].key).length == 0) {
        var regular_item = '<li class="hidden-sub-item" style="display:none;" id="item-' + this.shopify_cart.items[i].key + '" data-handle="' + this.shopify_cart.items[i].handle + '" data-parent-line="' + sub_item + '" data-variant-id="' + this.shopify_cart.items[k].id + '" data-sub-line="' + parseInt(i) + '">&nbsp;</li>';

      } else {
        var is_gift = false;
        for(var j in this.shopify_cart.items[i].properties) {
          if(j == '_is_gift' && this.shopify_cart.items[i].properties[j] == 1) {
            is_gift = true;
            break;
          }
        }


        var price = '<span class="final-line-price">$' + (this.shopify_cart.items[i].final_line_price/100).toString().replace('.00', '') + '</span>';

        if(this.shopify_cart.items[i].original_line_price > this.shopify_cart.items[i].final_line_price){
          price = '<strike>$' + (this.shopify_cart.items[i].original_line_price/100).toString().replace('.00', '') + '</strike>' + price;
        }

        var regular_item = '<li id="item-' + this.shopify_cart.items[i].key + '" data-handle="' + this.shopify_cart.items[i].handle + '">' +
          '<a class="product-image" href="' + this.shopify_cart.items[i].url + '">' +
            '<img src="' + this.shopify_cart.items[i].image + '" border="0" />' +
          '</a>' +
          '<h6 class="mini-heading remove-item"><a href="javascript:void(0)" data-quantity="' + this.shopify_cart.items[i].quantity + '" data-key="' + this.shopify_cart.items[i].key + '" data-line="' + parseInt(i) + '">Remove</a></h6>' +
          '<h6' + (this.shopify_cart.items[i].image ? ' class="product-title-with-image"':'') + '>' + this.shopify_cart.items[i].title + (is_gift ? ' (gift)' : '') + '</h6>' +
          '<div class="quantity-container">' +
            '<input type="number" id="quantity-' + this.shopify_cart.items[i].key + '" name="quantity" value="' + this.shopify_cart.items[i].quantity + '" min="1" max="9" pattern="/d*" maxlength="1" autocomplete="off" data-quantity="' + this.shopify_cart.items[i].quantity + '" data-key="' + this.shopify_cart.items[i].key + '" data-line="' + parseInt(i) + '"' + (is_gift ? 'class="disabled" disabled="disabled"' : '') + '>' +
            '<p class="price-container"><span>' + price + '</span></p>' +
          '</div>' +
          '<div style="clear:both;height:0px;">&nbsp;</div>' +
        '</li>';
      }
      $('#mini-cart-items').append(regular_item);
    }

    // set up mini-cart remove
    $('#mini-cart .remove-item > a').click(function() {
      $link = $(this);

      var updates = {};
      updates[$link.attr('data-line')] = 0;
      $('li[data-parent-line="' + $link.attr('data-line') + '"]').each(function() {
        updates[$(this).attr('data-sub-line')] = 0;
      });
      slate.cart.updateLines(updates);

    });

    // set up mini-cart quantity
    $('#mini-cart input[type="number"][name="quantity"]').change(function() {
      var $input = $(this);
      var new_quantity = parseInt($input.val());
      if(new_quantity == $input.attr('data-quantity')) return;

      if(new_quantity == 0) $(this).val($input.attr('data-quantity'));

      var updates = {};
      updates[$input.attr('data-line')] = new_quantity;
      $('li[data-parent-line="' + $input.attr('data-line') + '"]').each(function() {
        updates[$(this).attr('data-sub-line')] = new_quantity;
      });
      slate.cart.updateLines(updates);
    });

    // update totals
    this.updateTotals();
  },

  updateLines: function(updates, callback) {
    console.log('updateLines: attempt');
    //console.log(updates);

    var formatted_updates = [];
    for(var i in this.shopify_cart.items) {
      if(updates[i] !== undefined) {
        formatted_updates.push(updates[i]);
      } else {
        formatted_updates.push(this.shopify_cart.items[i].quantity);
      }
    }

    $.post(
      '/cart/update.js',
      {updates: formatted_updates},
      function(data) {
        console.log('updateLines: success');
        //console.log(data);
        if(typeof callback == 'function') {
          callback(data);
        } else {
          slate.cart.shopify_cart = data;
          slate.cart.buildMiniCart();
        }
      },
      'json'
    ).fail(function(data) {
      console.log('updateLines: failed');
      //console.log(data);
      slate.cart.buildMiniCart();
    });
  },

  updateTotals: function() {
    var total_items = 0;
    $('#mini-cart-items > li:not(.hidden-sub-item)').each(function() {
      total_items += parseInt($(this).find('input[name="quantity"]').first().val());
    });

    $('.cart-icon').text(total_items);
    if(total_items == 0) {
      $('.cart-icon').removeClass('has-items');
      $('#mini-cart-items .no-items-message').show();
      $('#mini-cart').addClass('no-items');
      $('#mini-cart .price-container > span').text('$0');

    } else {
      $('.cart-icon').addClass('has-items');
      $('#mini-cart-items .no-items-message').hide();
      $('#mini-cart').removeClass('no-items');


      var total_price = 0;
      $('#mini-cart-items > li:not(.hidden-sub-item)').each(function() {
        total_price += parseFloat($(this).find('.price-container .final-line-price').text().replace('$', ''));
      });

      $('#mini-cart .mini-cart-footer .price-container > span').text('$' + total_price.toString().replace('.00', '').replace('.0', ''));
    }
  },

  submitCartForm: function($form, callback) {
    $originaltext = $form.find('[type="submit"] > [data-add-to-cart-text]').text();
    $form.find('[type="submit"] > [data-add-to-cart-text]').attr('data-original-text', $originaltext).text('Adding...').addClass('disabled').prop('disabled', true);
    //var bundle = parseInt($form.find('[name="properties[_bundle]"]').val());
    //console.log('bundle:', bundle, OTHERLAND.standard_packaging, 'sup: ', OTHERLAND.eco_friendly_packaging_single);
    // var isEco = false;
    // var platForm = '';

    // find additional IDs and add them
    //$form.find('.more_ids').remove();
    $form.find('.additional_id_added').remove();
    $form.find('.additional_ids').each(function(idx) {
      var id = parseInt($(this).val());
      //var id = null;
      
      // var variant = OTHERLAND.eco_friendly_variants.filter(function(x){
      //   return x.variant_id === val || x.eco_friendly_variant_id === val
      // });
      
      //console.log(idx, $(this), val, 'variant:', variant);
      //idx = idx+1;
      //var $htmlId = $(this).attr('id');
      //id = $(this).val();

      // //Ensure proper variants (Standard or Eco-Friendly) for selected scents are added to order
      // if($htmlId === 'candle_1_variant_id' || $htmlId === 'candle_2_variant_id' || $htmlId === 'candle_3_variant_id' || $htmlId === 'candle_4_variant_id' || $htmlId === 'candle_5_variant_id' || $htmlId === 'candle_6_variant_id'){
      //   if((bundle === OTHERLAND.eco_friendly_packaging || bundle === OTHERLAND.eco_friendly_packaging_single || bundle === OTHERLAND.eco_friendly_packaging_six_pack) && variant[0] != null){
      //     id = variant[0].eco_friendly_variant_id;
      //     //TODO: Make sure variant is in stock, if not default to other variant, and packaging option
      //     $form.find('input[type="hidden"][name="properties[_' + $htmlId + ']"]').val(id);
      //     //$form.append('<input class="additional_id_added" type="hidden" name="properties[_candle_' + idx + '_variant_id]" value="' + id + '" />');
      //     isEco = true;
      //     platForm = $form.find('[name="properties[_platform]"]').val();
      //   } else if(bundle === OTHERLAND.standard_packaging || bundle === OTHERLAND.standard_packaging_single || bundle === OTHERLAND.standard_packaging_six_pack || bundle === OTHERLAND.holiday_packaging || bundle === OTHERLAND.holiday_packaging_single || bundle === OTHERLAND.holiday_packaging_six_pack && $(this).val() !== ''){
      //     id = $(this).val();
      //     //TODO: Make sure variant is in stock, if not default to other variant, and packaging option
      //     $form.find('input[type="hidden"][name="properties[_' + $htmlId + ']"]').val(id);
      //     //$form.append('<input class="additional_id_added" type="hidden" name="properties[_candle_' + idx + '_variant_id]" value="' + id + '" />');
      //   }
      // } else if($(this).val() !== '') {
      //   id = $(this).val();
      // }

      if(id != null && id !== ''){
        $form.append('<input class="additional_id_added" type="hidden" name="id[]" value="' + id + '" />');
      }
    });

    $form.find('[name="id"]').attr('name', 'id[]');

    //If eco-friendly, remove platform
    // if(isEco){
    //   $form.find('.additional_id_added[value="' + platForm +'"]').remove();
    // }
 
    $.post(
      '/cart/add.js',
      $form.serialize(),
      function(data) {
        console.log('addItemToCart: success');
        //console.log(data);

        if(typeof callback == 'function') {
          callback(data);
        } else {
          $.get('/cart.js', {}, function(data) {
            slate.cart.shopify_cart = data;
            slate.cart.buildMiniCart();
            $('#mini-cart').addClass('is-open');
          }, 'json');

          $form.find('[type="submit"] > [data-add-to-cart-text]').text('Added!');
          window.setTimeout(function(){
            $form.find('[type="submit"] > [data-add-to-cart-text]').text($form.find('[type="submit"] > [data-add-to-cart-text]').attr('data-original-text')).prop('disabled', false).removeClass('disabled');
          }, 1000);
        }

      },
      'json'
    ).fail(function(data) {
      console.log('addItemToCart: error');
      //console.log(data);
      $form.find('[type="submit"] > [data-add-to-cart-text]').text('Sold Out');
      window.setTimeout(function(){
        $form.find('[type="submit"] > [data-add-to-cart-text]').text($form.find('[type="submit"] > [data-add-to-cart-text]').attr('data-original-text')).prop('disabled', false).removeClass('disabled');
      }, 1000);
    });
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    // preload images
    $('.product-image img').each(function() {
      var i = new Image();
      i.src = $(this).attr('src');
    });

    $(".product-image").swipe( {
      //Generic swipe handler for all directions
      swipe:function(e, direction, distance, duration, fingerCount, finterData) {
        if(direction == 'right') {
          if( $('.product-image-pagination > a.selected').prev().length > 0) {
            $('.product-image-pagination > a.selected').prev().trigger('click', ['right', 500]);
          } else {
            $('.product-image-pagination > a:last').trigger('click', ['right', 500]);
          }

        } else {
          if( $('.product-image-pagination > a.selected').next().length > 0) {
            $('.product-image-pagination > a.selected').next().trigger('click', ['left', 500]);
          } else {
            $('.product-image-pagination > a:first').trigger('click', ['left', 500]);
          }
        }
      },
      //Default is 75px, set to 0 for demo so any distance triggers swipe
       threshold:10
    });

    $('.product-image-pagination > a').on('click', function(e, direction, timing) {
      e.preventDefault();

      if(timing == undefined) timing = 500;

      $visibleImage = $(this).closest('.product-image').find('img:visible').first();
      $clickedImage = $(this).closest('.product-image').find('#product-image-' + ($(this).closest('.product-image').find('a').index($(this))+1));
      if(direction == 'right') {
        $visibleImage.hide("fade", {  }, timing);
        $clickedImage.show("fade", {  }, timing);
      } else {
        $visibleImage.hide("fade", {  }, timing);
        $clickedImage.show("fade", {  }, timing);
      }

      $('.product-image-pagination > a').removeClass('selected');
      $(this).addClass('selected');
    });

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featured_image.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



document.ontouchstart=function(){
  $('.mobile-site-nav-bottom').animate({bottom:0},1);
}
var hovered_over_menu = null;
$(document).ready(function() {
  // enable banner videos
  $('.background-video-player').vimeo_player();

  $('.site-nav--has-submenu > a').on('mouseover', function(e) {
    $('.site-nav__submenu[data-handle="' + $(this).attr('data-handle') + '"]').css('left', $(this).offset().left).addClass('submenu--is-open');
    hovered_over_menu = $(this).attr('data-handle');
  });
  $('.site-nav__submenu').on('mouseover', function(e) {
    hovered_over_menu = $(this).attr('data-handle');
  });

  $('.site-nav--has-submenu, .site-nav__submenu').on('mouseout', function(e) {
    hovered_over_menu = null;
    setTimeout(
      function(x) {
        return function() {
          if(hovered_over_menu === null || hovered_over_menu != x.attr('data-handle')) {
            $('.site-nav__submenu[data-handle="' + x.attr('data-handle') + '"]').removeClass('submenu--is-open');
          }
        };
      }($(this)),
      200
    );
  });



  // set up header
  var menu_height = 0;
  $('#mobile-site-nav-list > li').each(function() {
    menu_height = menu_height + $(this).outerHeight();
  });
  if($(window).height()-56 > menu_height) {
    var top_padding = Math.ceil(($(window).height() - 56 - menu_height ) / 2);
    $('#mobile-site-nav-list > li:first-child').css('paddingTop', top_padding);
  }
  $('#mobile-hamburger-toggle').click(function(e) {
    e.preventDefault();

    if($('#mini-cart').hasClass('is-open')) {
      $('#mini-cart').removeClass('is-open');
    }

    if($('#mobile-site-nav-list').hasClass('show-menu')) {
      $('#mobile-site-nav-list').removeClass('show-menu');
      $(this).removeClass('no-hamburgler');
      $('body').css('overflow', 'auto');
    } else {
      //window.scroll(0,0);
      $('#mobile-site-nav-list').addClass('show-menu');
      $(this).addClass('no-hamburgler');
      $('body').css('overflow', 'hidden');
    }
  });


  // promo bar
  // if($('#promo-bar').length > 0 && $('#promo-bar').is(':visible')) {
  //   if(Cookies.get('promo-bar-hidden') != '1') {
  //     showPromoBar();
  //     resizePromoBar();
  //     $('.promo-bar-close').click(function() {
  //       hidePromoBar();
  //     });
  //   } else {
  //     $('#promo-bar').hide();
  //   }
  // }

  // top bar
  // if($('#top-bar').length > 0 && $('#top-bar').is(':visible')) {
  //   showTopBar();
  // }

  $('a[rel="modal:open"]').click(function(event) {
    $(this).modal({
      fadeDuration: 250
    });
    return false;
  });

  // set up product quantities
  $('input[type="number"][name="quantity"]').keyup(function() {
    if(parseInt($(this).val()) == 0) $(this).val('1');
    if(parseInt($(this).val()) > 9) $(this).val('9');
    $(this).val($(this).val().match(/[0-9]*/));
  });
  $('input[type="number"][name="quantity"]').blur(function() {
    if(parseInt($(this).val()) == 0 || $(this).val() == '') $(this).val('1');
    if(parseInt($(this).val()) > 9) $(this).val('9');
    $(this).val($(this).val().match(/[0-9]*/));
  });

  // faq page
  if($('.faq-sidebar').length) {
    var lastId,
        topMenu = $(".faq-sidebar ul"),
        menuItems = topMenu.find("a"),
        scrollItems = menuItems.map(function(){
          var item = $($(this).attr("href"));
          if (item.length) { return item; }
        });

    // animate scroll to anchor
    menuItems.click(function(e) {
      e.preventDefault();
      var faq_section = $('div' + $(this).attr('href'));
      $('html,body').animate({scrollTop: faq_section.offset().top - $('#shopify-section-header').height() - 30}, 'slow');
      window.location.hash = $(this).attr('href');
    });

    // highlight selected menu item on scroll
    /*
    var sidebar_menu_top = $('#shopify-section-header').height() - $(window).scrollTop();
    if(sidebar_menu_top < 0) sidebar_menu_top = 0;
    $('.faq-sidebar').css('top', sidebar_menu_top);
    */
    $('.faq-sidebar').css('top', $('#shopify-section-header').height());
    var scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();
    var sidebar_menu_height_adjustment = $('#shopify-section-footer').outerHeight() - scrollBottom + 1;
    if(sidebar_menu_height_adjustment < 0) sidebar_menu_height_adjustment = 0;
    sidebar_menu_height_adjustment = sidebar_menu_height_adjustment + $('#shopify-section-header').height() + 1;
    $('.faq-sidebar').css('height', 'calc(100vh - ' + sidebar_menu_height_adjustment + 'px)');
    $(window).scroll(function(e) {
      var sidebar_menu_top = $('#shopify-section-header').height() - $(this).scrollTop();
      if(sidebar_menu_top < 0) sidebar_menu_top = 0;
      //$('.faq-sidebar').css('top', sidebar_menu_top);
      var scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();
      var sidebar_menu_height_adjustment = $('#shopify-section-footer').outerHeight() - scrollBottom + 1;
      if(sidebar_menu_height_adjustment < 0) sidebar_menu_height_adjustment = 0;
      sidebar_menu_height_adjustment = sidebar_menu_height_adjustment + $('#shopify-section-header').height() + 1;
      $('.faq-sidebar').css('height', 'calc(100vh - ' + sidebar_menu_height_adjustment + 'px)');

      var cur = scrollItems.map(function() {
        if($(this).offset().top - $(window).height() + 50 < $(window).scrollTop()) return this;
      });
      cur = cur[cur.length-1];
      var id = cur && cur.length ? cur[0].id : scrollItems[0].id;

      if (lastId !== id) {
        lastId = id;
        menuItems.removeClass("selected");
        menuItems.filter('[href="#'+id+'"]').addClass("selected");
      }
    });

    // toggle answer when icon is clicked
    $('.question .plus').click(function() {
      $('.answer').slideUp();
      $('.question .plus').show();
      $('.question .close').hide();
      $(this).closest('li').find('.answer').slideDown();
      $(this).hide();
      $(this).closest('li').find('.question .close').show();
    });
    $('.question h5').click(function() {
      if($(this).closest('.question').find('.plus').is(':visible')) {
        $(this).closest('.question').find('.plus:visible').trigger('click');
      } else {
        $(this).closest('.question').find('.close:visible').trigger('click');
      }
    });
    $('.question .close').click(function() {
      $(this).closest('li').find('.answer').slideUp();
      $(this).hide();
      $(this).closest('li').find('.question .plus').show();
    });

  }

  // footer mailing list
  $('#footer-mailing-list').submit(function(e) {

    $(this).find('input[name="email"]').val();
    $(this).find('input[type="submit"]').attr('data-original-text', $(this).find('input[type="submit"]').val());
    $(this).find('input[type="submit"]').val('Subscribed!');
    setTimeout(function() {
      $('#footer-mailing-list').find('input[type="submit"]').val($('#footer-mailing-list').find('input[type="submit"]').attr('data-original-text'));
    }, 1000);
  });

  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // cart things
  slate.cart.initCart();

  // preload images
  $('.product-image img').each(function() {
    var i = new Image();
    i.src = $(this).attr('src');
  });

  $(".product-image").swipe( {
    //Generic swipe handler for all directions
    swipe:function(e, direction, distance, duration, fingerCount, finterData) {
      if(direction == 'right') {
        if( $('.product-image-pagination > a.selected').prev().length > 0) {
          $('.product-image-pagination > a.selected').prev().trigger('click', ['right', 500]);
        } else {
          $('.product-image-pagination > a:last').trigger('click', ['right', 500]);
        }

      } else {
        if( $('.product-image-pagination > a.selected').next().length > 0) {
          $('.product-image-pagination > a.selected').next().trigger('click', ['left', 500]);
        } else {
          $('.product-image-pagination > a:first').trigger('click', ['left', 500]);
        }
      }
    },
    //Default is 75px, set to 0 for demo so any distance triggers swipe
     threshold:10
  });

  $('.product-image-pagination > a').on('click', function(e, direction, timing) {
    e.preventDefault();

    if(timing == undefined) timing = 500;

    $visibleImage = $(this).closest('.product-image').find('img:visible').first();
    $clickedImage = $(this).closest('.product-image').find('#product-image-' + ($(this).closest('.product-image').find('a').index($(this))+1));
    if(direction == 'right') {
      $visibleImage.hide("fade", {  }, timing);
      $clickedImage.show("fade", {  }, timing);
    } else {
      $visibleImage.hide("fade", {  }, timing);
      $clickedImage.show("fade", {  }, timing);
    }

    $('.product-image-pagination > a').removeClass('selected');
    $(this).addClass('selected');
  });

  /* start seasonal */
  $('.seasonal .variant-selector a').click(function() {
    $('.variant-selector li').addClass('inactive');
    $(this).closest('li').removeClass('inactive');
    $('.product-image-pagination > a[data-variant-id="' + $(this).closest('li').attr('data-variant-id') + '"]').trigger('click');
    $('.variant-price[data-variant-id!="' + $(this).closest('li').attr('data-variant-id') + '"]').hide();
    $('.variant-price[data-variant-id="' + $(this).closest('li').attr('data-variant-id') + '"]').show();
    if($(this).closest('li').attr('data-variant-id') == 'the-threesome') {
      $('.specs').hide();
      $('.variant-title').show();
      $('.variant-descriptors').show();
      window.history.pushState('variant', 'Variant', '?');
    } else {
      $('.specs').hide();
      $('.variant-title[data-variant-id!="' + $(this).closest('li').attr('data-variant-id') + '"]').hide();
      $('.variant-title[data-variant-id="' + $(this).closest('li').attr('data-variant-id') + '"]').show();
      $('.variant-descriptors[data-variant-id!="' + $(this).closest('li').attr('data-variant-id') + '"]').hide();
      $('.variant-descriptors[data-variant-id="' + $(this).closest('li').attr('data-variant-id') + '"]').show();
      // Persistent UTM & Tracking Fix
      var original_search_params = new URLSearchParams(window.location.search)
      var params_obj =  Object.fromEntries(original_search_params.entries());
      delete params_obj['variant']
      const newQueryString = new URLSearchParams(params_obj).toString()
      window.history.pushState('variant', 'Variant', '?variant=' + $(this).closest('li').attr('data-variant-id') + `${newQueryString && `&${newQueryString}`}`);

      $('.add-to-cart-container').show();

      if($(this).closest('li').attr('data-available') == 'false') {
        $('#add_to_cart_container_top').find('button').addClass('disabled').prop('disabled', 'disabled');
        $('#add_to_cart_container_top').find('button > span').text('Sold Out');
        $('#global_quantity').addClass('disabled').prop('disabled', 'disabled');
        $('.seasonal [data-add-to-cart-seasonal]').prop('disabled', 'disabled')
      } else {
        $('#global_quantity').removeClass('disabled').removeProp('disabled');
        $('#add_to_cart_container_top').find('button').removeClass('disabled').removeProp('disabled');
        $('#add_to_cart_container_top').find('button > span').text('Add To Cart');
        $('.seasonal [data-add-to-cart-seasonal]').prop('disabled', false)
      }
    }
  });

  // check URL to see if there was a variant specified - if not, select the threesome
  var selected_variant = getURLParameter('variant');
  if(selected_variant) {
    $('.seasonal .variant-selector li[data-variant-id="' + selected_variant + '"] a').trigger('click');
  }
  // } else {
  //   $('.seasonal .variant-selector li:first a').trigger('click');
  // }

  $('.seasonal [data-add-to-cart-seasonal]').click(function() {
    //console.log('hey add', variant_id)
    var variant_id = $('.variant-selector li:not(.inactive)').first().attr('data-variant-id');
    $('#add-form-' + variant_id + ' input[name="quantity"]').val($('#global_quantity').val());
    $('#add-form-' + variant_id).trigger('submit');
  });

  $('[data-add-product]').click(function(e) {
    e.preventDefault();
    $(this).closest('.promos').find('#add-form').trigger('submit');
  });
  /* end seasonal */

  /* Buy Bundles */
  $('[data-buy-bundle], [data-buy-all]').each(function(){
    var $addForm = $(this).find('#add-form');
    
    //If no form is found on context of a bundle block, find on page
    if($addForm.length === 0){
      $addForm = $('#add-form');
    }

    var $bundle = $(this);
    var $giftForm = $(this).find('.promo-gift-form');
    var $promo = $(this).find('.promo-block');
    var $backBtn = $(this).find('.promo-back-btn');
    var $continueBtn = $(this).find('#bundle-gift-continue-btn');
    var $skipNoteBtn = $(this).find('#bundle-skip-note-btn');
    var $orderNote = $(this).find('#add-form #order_note');
    var $recipient = $(this).find('[name="properties[Recipient]"]');
    var $message = $(this).find('[name="properties[Message]"]');
    var $signature = $(this).find('[name="properties[Signature]"]');
    var $giftName = $(this).find('#gift_name');
    var $giftGiver = $(this).find('#gift_giver');
    var $giftMessage = $(this).find('#gift_message');
    var $candleOneVariantID = $(this).find('#add-form #candle_1_variant_id');
    var $candleTwoVariantID = $(this).find('#add-form #candle_2_variant_id');
    var $candleThreeVariantID = $(this).find('#add-form #candle_3_variant_id');
    var $matchboxID = $(this).find('#add-form [data-matchbox]').last();
    var $customizeBtn = $(this).find('[data-customize]');
    var $addToCartBtn = $(this).find('[data-add-to-cart]');

    $customizeBtn.on('click', function(e){
      e.stopPropagation();
    });

    $(this).unbind('submit');

    $backBtn.on('click', function(e){
      $giftForm.hide();
      e.preventDefault();
      $('body').removeClass('pin-body');
      $('#gift_name, #gift_message, #gift_giver').val('');
      $('[data-gift-chars-left]').each(function(){
        $(this).text($(this).attr('data-max'));
      });
      return false;
    });

    $giftForm.on('click', function(e){
      if(e.target === $giftForm[0]){
        $giftForm.hide();
        e.preventDefault();
        $('body').removeClass('pin-body');
        $('#gift_name, #gift_message, #gift_giver').val('');
        $('[data-gift-chars-left]').each(function(){
          $(this).text($(this).attr('data-max'));
        });
        return false;
      }
    });

    $continueBtn.on('click', function(e){
      e.preventDefault();
      $orderNote.val($matchboxID.val() + '}}' + $giftName.val() + '}}' + $giftMessage.val() + '}}' + $giftGiver.val() + '}}' + $candleOneVariantID.val() + '}}' + $candleTwoVariantID.val() + '}}' + $candleThreeVariantID.val());
      console.log($orderNote.val());
      $addForm.trigger('submit');
    });

    $skipNoteBtn.on('click', function(e){
      $orderNote.val('');
      $recipient.val('');
      $message.val('');
      $signature.val('');
      console.log($orderNote.val());
      $addForm.trigger('submit');
    })
  
    $addToCartBtn.on('click', function(){
      if($(this)[0].hasAttribute('data-is-gift')){
        $giftForm.show();
        $('body').addClass('pin-body');
      } else {
        $addForm.trigger('submit');
      }
    });
  });

  /* Buy all (3 or 6) - PDP */
  $('[data-buy-all]').each(function(){
    var sixPack = $('#add-form-the-six-pack, #add-form-the-three-pack');

    $(this).on('click', function(){
      sixPack.trigger('submit');
    });
  });

  $('.advert').click(function() {
    $(this).find('a').first()[0].click();
  });
});

$(window).on("load", function() {
  $('#shopify-section-featured-collection,.candle-collection-display').each(function() {
    var scroll_cutoff = ( $(this).find('ul')[0].scrollWidth - $(window).width() ) / 2;
    $(this).find('ul').scrollLeft(scroll_cutoff);
  });
  $('.fade-me-in').each(function() {
    if($(this).hasClass('asap')) {
      var addition = 100;
    } else {
      var addition = $(this).height()/5;
    }
    if($(window).scrollTop()+$(window).height() > $(this).offset().top + addition) {
      if($(this).attr('data-fade-in')) { var timeout = parseInt($(this).attr('data-fade-in')); } else { var timeout = 0; }
      $(this).addClass('invisible').removeClass('fade-me-in');
      setTimeout(function() { $(this).addClass('fade-in').removeClass('invisible'); }.bind(this), timeout);
    }
  });
  $('.fade-me-out').each(function() {
    if($(this).attr('data-fade-out')) { var timeout = parseInt($(this).attr('data-fade-out')); } else { var timeout = 0; }
    setTimeout(function() { $(this).addClass('invisible').removeClass('fade-me-out'); }.bind(this), timeout);
  });
});

var candle_heading_top_position;
$(window).scroll(function() {
  $('.fade-me-in').each(function() {
    if($(this).hasClass('asap')) {
      var addition = 100;
    } else {
      var addition = $(this).height()/5;
    }
    if($(window).scrollTop()+$(window).height() > $(this).offset().top + addition) {
      if($(this).attr('data-fade-in')) { var timeout = parseInt($(this).attr('data-fade-in')); } else { var timeout = 0; }
      $(this).addClass('invisible').removeClass('fade-me-in');
      setTimeout(function() { $(this).addClass('fade-in').removeClass('invisible'); }.bind(this), timeout);
    }
  });

  /* promo bar stuff */
  // if($('#promo-bar').length > 0) {
  //   var promoBarHeight = $('#promo-bar').height() ? parseInt($('#promo-bar').height()) : 0;
  //   var topBarHeight = $('#top-bar').height() ? parseInt($('#top-bar').height()) : 0;
  //   var scrollTop = $(window).scrollTop();

  //   // set up header
  //   var menu_height = 0;
  //   $('#mobile-site-nav-list > li').each(function() {
  //     menu_height = menu_height + $(this).outerHeight();
  //   });

  //   if(scrollTop < promoBarHeight + topBarHeight) {
  //     var promo_bar_top = -scrollTop + 'px';
  //     $('#').css('top', promo_bar_top);
  //     $('#promo-bar').css('marginBottom', promo_bar_top);
  //     $('body').addClass('has-promo-bar');

  //     var mobile_header_top = 55 + promoBarHeight + topBarHeight - scrollTop;
  //     $('#shopify-section-header #mobile-site-nav-list').css('top', mobile_header_top + 'px');

  //     var submenu_top = 90 + promoBarHeight + topBarHeight - scrollTop;
  //     $('#shopify-section-header ul.site-nav__submenu').css('top', submenu_top + 'px');

  //     $('#shopify-section-header div#mini-cart').css('top', getMiniCartTop() + 'px');

  //     var padding_amount = $(window).height() - 56 - promoBarHeight + topBarHeight + scrollTop;
  //     // if(padding_amount > menu_height) {
  //     //   var top_padding = Math.ceil((padding_amount - menu_height ) / 2);
  //     //   $('#mobile-site-nav-list > li:first-child').css('paddingTop', top_padding);
  //     // }

  //   } else {
  //     var submenu_top = 90 + topBarHeight;
  //     //var minicart_top = 100 + parseInt($('#top-bar').height());
  //     var mobileNav_top = 50 + topBarHeight;
  //     $('body').removeClass('has-promo-bar');

  //     var mq = window.matchMedia( "(min-width: 990px)" );

  //     $('#promo-bar').css('top', -promoBarHeight + 'px');
  //     $('#promo-bar').css('marginBottom', -promoBarHeight + 'px');
  //     $('#shopify-section-header #mobile-site-nav-list').css('top', mobileNav_top + 'px');
  //     $('#shopify-section-header ul.site-nav__submenu').css('top', submenu_top + 'px');

  //     $('#shopify-section-header div#mini-cart').css('top', getMiniCartTop() + 'px');

  //     // if($(window).height()-56 > menu_height) {
  //     //   var top_padding = Math.ceil(($(window).height() - 56 - menu_height ) / 2);
  //     //   $('#mobile-site-nav-list > li:first-child').css('paddingTop', top_padding);
  //     // }
  //   }

  // }
  /* end promo bar stuff */

  /* fix candle heading */
  if($('.candle-heading').length > 0 && $('.candle-heading').is(':visible')) {
    if(!$('.candle-heading').hasClass('fixed')) {
      candle_heading_top_position = $('.candle-heading').offset().top-parseInt($('.candle-heading').css('margin-top').replace('px', ''));
    }
    if(!$('.candle-heading').hasClass('fixed') && $(window).scrollTop()+$('header').height() > $('.candle-heading').offset().top-parseInt($('.candle-heading').css('margin-top').replace('px', ''))) {
      $('.candle-heading').addClass('fixed');
      $('#shopify-section-featured-collection').css('padding-top', $('.candle-heading').outerHeight());
    } else if($(window).scrollTop()+$('header').height() < candle_heading_top_position) {

      $('.candle-heading').removeClass('fixed');
      $('#shopify-section-featured-collection').css('padding-top', '0px');
      candle_heading_top_position = $('.candle-heading').offset().top-parseInt($('.candle-heading').css('margin-top').replace('px', ''));
      if($(window).scrollTop()+$('header').height() > $('.candle-heading').offset().top-parseInt($('.candle-heading').css('margin-top').replace('px', ''))) {
        $('.candle-heading').addClass('fixed');
        $('#shopify-section-featured-collection').css('padding-top', $('.candle-heading').outerHeight());
      }
    }
  }
});

function resizePromoBar() {
  let mql = window.matchMedia('(min-width: 800px)');
  if(mql.matches){
    $('#promo-bar').height('100px');
  } else {
    $('#promo-bar').height('70px');
  }
}

resizePromoBar();
setBodyPadding();

$(window).on('resize', function(){
  resizePromoBar();
  setBodyPadding();
});

function setBodyPadding() {
  $('#shopify-section-header div#mini-cart').css('top', getMiniCartTop() + 'px');
  var promoBarHeight = $('#promo-bar').height() ? parseInt($('#promo-bar').height()) : 0;
  var topBarHeight = $('#top-bar').height() ? parseInt($('#top-bar').height()) : 0;
  var headerHeight = $('header[role=banner]').height() ? parseInt($('header[role=banner]').height()) : 0;
  //var padding = topBarHeight + promoBarHeight + headerHeight;
  var padding = topBarHeight + headerHeight;
  $("body").css('paddingTop', padding + 'px');

  $('#shopify-section-header #mobile-site-nav-list').css('top', 55 + topBarHeight + 'px');
  $('#shopify-section-header ul.site-nav__submenu').css('top', 90 + topBarHeight + 'px');
  $('#shopify-section-header div#mini-cart').css('top', getMiniCartTop() + 'px');
  $('.sticky-container').css('top', 20 + padding + 'px');
}

function getURLParameter(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}

// function showPromoBar() {
//     resizePromoBar();
//     var promoBarHeight = $('#promo-bar').height() ? parseInt($('#promo-bar').height()) : 0;
//     var topBarHeight = $('#top-bar').height() ? parseInt($('#top-bar').height()) : 0;
//     var scrollTop = $(window).scrollTop();
//     //var padding = parseInt($('body').css('paddingTop').replace('px', '')) + $('#promo-bar').height();
//     var padding = parseInt($('body').css('paddingTop').replace('px', '')) + topBarHeight;

//     $('body').addClass('has-promo-bar');

//     $("#promo-bar").animate({
//        top: '0px',
//        marginBottom: '0px',
//     }, { duration: 200, queue: false, complete: function() {

//       // set up header
//       $('#mobile-site-nav-list > li:first-child').css('paddingTop', '0px');
//       var menu_height = 0;
//       $('#mobile-site-nav-list > li').each(function() {
//         menu_height = menu_height + $(this).outerHeight();
//       });

//       var padding_amount = $(window).height() - 56 - ($('#promo-bar').height() - scrollTop);
//       // if(padding_amount > menu_height) {
//       //   var top_padding = Math.ceil((padding_amount - menu_height ) / 2);
//       //   $('#mobile-site-nav-list > li:first-child').css('paddingTop', top_padding);
//       // }

//     } });

//     // $("body").animate({
//     //    paddingTop: padding + 'px'
//     // }, { duration: 200, queue: false });

//     $("body").css('paddingTop', padding);

//     //$('#shopify-section-header #mobile-site-nav-list').css('top', 55 + promoBarHeight + 'px');
//     //$('#shopify-section-header ul.site-nav__submenu').css('top', 90 + promoBarHeight + 'px');
//     $('#shopify-section-header #mobile-site-nav-list').css('top', 55 + topBarHeight + 'px');
//     $('#shopify-section-header ul.site-nav__submenu').css('top', 90 + topBarHeight + 'px');
//     $('#shopify-section-header div#mini-cart').css('top', getMiniCartTop() + 'px');
// }

// function hidePromoBar() {
//     var promoBarHeight = $('#promo-bar').height() ? parseInt($('#promo-bar').height()) : 0;
//     var topBarHeight = $('#top-bar').height() ? parseInt($('#top-bar').height()) : 0;
//     var scrollTop = $(window).scrollTop();
//     //var padding = parseInt($('body').css('paddingTop').replace('px', '')) - promoBarHeight;
//     var padding = parseInt($('body').css('paddingTop').replace('px', '')) - topBarHeight;

//     $('body').removeClass('has-promo-bar');

//     $("#promo-bar").animate({
//        top: -1 * promoBarHeight + 'px',
//        marginBottom: -1 * promoBarHeight + 'px',
//     }, { duration: 200, queue: false, complete: function() {
//       $('#promo-bar').hide();
//       Cookies.set('promo-bar-hidden', '1');
      
//       $('#shopify-section-header #mobile-site-nav-list').css('top', '55px');
//       $('#shopify-section-header ul.site-nav__submenu').css('top', '90' + $('#top-bar').height() + 'px');
//       $('#shopify-section-header div#mini-cart').css('top', '190px');
//     } });

//     $("body").animate({
//        paddingTop: padding + 'px'
//     }, { duration: 200, queue: false });
// }

// function showTopBar() {
//     var promoBarHeight = $('#promo-bar').height() ? parseInt($('#promo-bar').height()) : 0;
//     var topBarHeight = $('#top-bar').height() ? parseInt($('#top-bar').height()) : 0;
//     var scrollTop = $(window).scrollTop();
//     //var padding = parseInt($('body').css('paddingTop').replace('px', '')) + topBarHeight + promoBarHeight;
//     var padding = parseInt($('body').css('paddingTop').replace('px', '')) + topBarHeight;
//     console.log(parseInt($('body').css('paddingTop').replace('px', '')), topBarHeight);

//     // $("#top-bar").animate({
//     //    top: '0px',
//     //    marginBottom: '0px',
//     // }, { duration: 200, queue: false, complete: function() {

//     //   // set up header
//     //   $('#mobile-site-nav-list > li:first-child').css('paddingTop', '0px');
//     //   var menu_height = 0;
//     //   $('#mobile-site-nav-list > li').each(function() {
//     //     menu_height = menu_height + $(this).outerHeight();
//     //   });

//     //   //var padding_amount = $(window).height() - 56 - promoBarHeight - scrollTop;
//     //   var padding_amount = $(window).height() - 56 - topBarHeight - scrollTop;
//     //   // if(padding_amount > menu_height) {
//     //   //   var top_padding = Math.ceil((padding_amount - menu_height ) / 2);
//     //   //   $('#mobile-site-nav-list > li:first-child').css('paddingTop', top_padding);
//     //   // }

//     // } });

//     // $("body").animate({
//     //   //  paddingTop: padding + 'px'
//     //   paddingTop: padding + 'px'
//     // }, { duration: 200, queue: false });

//     //$("body").css("paddingTop", padding);
    
//     // $('#shopify-section-header #mobile-site-nav-list').css('top', 55 + promoBarHeight + topBarHeight + 'px');
//     // $('#shopify-section-header ul.site-nav__submenu').css('top', 90 + promoBarHeight + topBarHeight + 'px');
//     $('#shopify-section-header #mobile-site-nav-list').css('top', 55 + topBarHeight + 'px');
//     $('#shopify-section-header ul.site-nav__submenu').css('top', 90 + topBarHeight + 'px');
//     $('#shopify-section-header div#mini-cart').css('top', getMiniCartTop() + 'px');
// }

function getMiniCartTop(){
  var mq = window.matchMedia( "(min-width: 990px)" );
  var promoBarHeight = $('#promo-bar').height() ? parseInt($('#promo-bar').height()) : 0;
  var topBarHeight = $('#top-bar').height() ? parseInt($('#top-bar').height()) : 0;
  var scrollTop = $(window).scrollTop();
  var offset = mq.matches ? 100 : 65;

  //if(scrollTop < promoBarHeight + topBarHeight) {
  if(scrollTop < topBarHeight) {
    //var minicart_top = offset + promoBarHeight + topBarHeight - scrollTop;
    var minicart_top = offset + topBarHeight - scrollTop;
  } else {
    var minicart_top = offset + topBarHeight;
  }
  
  return minicart_top;
}

jQuery(document).ready(function(){
  var $clock = jQuery('.promo-countdown'),
      $productCountdown = jQuery('.product-countdown'),
      eventTime = moment('30-11-2023 03:00:00', 'DD-MM-YYYY HH:mm:ss').unix(),
      currentTime = moment().unix(),
      diffTime = eventTime - currentTime,

      duration = moment.duration(diffTime * 1000, 'milliseconds'),
      interval = 1000;

  // if time to countdown
  if(diffTime > 0) {
      $clock.show();
      var $d = jQuery('.countdown-days__val span'),
          $h = jQuery('.countdown-hrs__val span'),
          $m = jQuery('.countdown-mins__val span'),
          $s = jQuery('.countdown-secs__val span');

      $clock.css({'display': 'flex'});
      calcTime();

      setInterval(function(){
        calcTime();
      }, interval);
  } else {
    $clock.hide();
    $productCountdown.hide();
  }

  function calcTime() {
    duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
    var d = moment.duration(duration).days(),
        h = moment.duration(duration).hours(),
        m = moment.duration(duration).minutes(),
        s = moment.duration(duration).seconds();

    
    // if(parseInt(d) > 0){
    //   $('.days, .days-sep').show();
    // }

    d = jQuery.trim(d).length === 1 ? '0' + d : d;
    h = jQuery.trim(h).length === 1 ? '0' + h : h;
    m = jQuery.trim(m).length === 1 ? '0' + m : m;
    s = jQuery.trim(s).length === 1 ? '0' + s : s;

    // show how many hours, minutes and seconds are left
    $d.html(d);
    $h.html(parseInt(h) + parseInt(d * 24));
    $m.html(m);
    $s.html(s);
  }
});

jQuery(document).ready(function($){
    $('.section-bundles').each(function(){
      var $title = $(this).find('.section-bundles__title').first().html();
      $('.bundle-filters').append('<a class="btn chronicle-semi btn-small" href="#" data-filter-bundles="' + $title.toLowerCase() + '">' + $title + '</a>') 
    });

    var $bundleFilters = $('.bundle-filters a');
    var $sectionBundles = $('.section-bundles[data-bundle]');

    $bundleFilters.on('click', function(e) {
      e.preventDefault();
      $bundleFilters.removeClass('active');
      $(this).addClass('active');
      // $(this).append('<span class="national-book"><svg width="20" height="20" viewBox="0 0 20 20" class="icon"><path fill="currentColor" d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg></span>');
      $filter = $(this).attr('data-filter-bundles');
      console.log($('.section-bundles[data-bundle="' + $filter.toLowerCase() + '"]'));
      if($filter === 'all'){
        $sectionBundles.show();
      } else {
        $sectionBundles.hide();
        $('.section-bundles[data-bundle="' + $filter.toLowerCase() + '"]').show();
      }
      
    });
});
